import create, { GetState, SetState } from 'zustand';
import { devtools } from 'zustand/middleware';

import { Location } from 'src/types';

interface MainStore {
  initialLoadComplete: boolean;
  selectedLocations: Location[] | null;
  setInitialLoadComplete: (value: boolean) => void;
  setSelectedLocations: (locations: Location[]) => void;
}

const useMainStore = create<MainStore>(
  devtools(
    (set: SetState<MainStore>, get: GetState<MainStore>) => ({
      initialLoadComplete: false,
      selectedLocations: [] as Location[],
      setInitialLoadComplete: (value: boolean) => set(() => ({ initialLoadComplete: value })),
      setSelectedLocations: (locations: Location[]) => set({ selectedLocations: locations }),
    }),
    { name: 'mainStore' }
  )
);

export default useMainStore;
